import { createContext, useContext } from 'react';

export interface SidebarCollapseValue {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  toggle: () => void;
}

const SidebarCollapseContext = createContext<SidebarCollapseValue | null>(null);

export function useSidebarCollapse(): SidebarCollapseValue {
  const value = useContext(SidebarCollapseContext);
  if (!value) {
    throw new Error('useSidebarCollapse must be used inside SidebarCollapseProvider');
  }
  return value;
}

export const SidebarCollapseProvider = SidebarCollapseContext.Provider;
